import * as React from "react";
import { connect } from "react-redux";
import debounce from "lodash.debounce";

import { changeWorklistFilter } from "../../../../actions/fetchWorkItemsActions";
import styles from "./Searchbox.module.css";
import "../../../../css/site.css";
import searchIcon from "./icon-search.svg";
import { selectTextFilterInput } from "selector/workItemSelectors";
import { changeFilterInput } from "actions/fetchWorkItemsActions";

const Searchbox = ({ value, onChange }) => {
  return (
    <label className={styles.frame}>
      <input
        type="search"
        value={value}
        placeholder="Search"
        autoFocus={true}
        className={styles.text}
        onChange={event => onChange(event.target.value)}
        id="Searchbox_claim"
      />
      <img
        alt=""
        style={{ height: 16 }}
        className={styles.icon}
        src={searchIcon}
      />
    </label>
  );
};

const mapStateToProps = state => {
  return {
    value: selectTextFilterInput(state)
  };
};

const mapDispatchToProps = dispatch => {
  const debouncedOnChange = debounce(
    value =>
      dispatch(
        changeWorklistFilter({
          name: "value",
          value: value
        })
      ),
    3000
  );

  return {
    onChange: value => {
      dispatch(changeFilterInput("text", value));
      debouncedOnChange(value);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Searchbox);
